import { ServiceLineItem } from '../../shared/types';

/**
 * Returns the service lines for an invoice/settings object, falling back to a
 * single line derived from the legacy serviceDescription/hours/minutes fields
 * for invoices saved before multi-line support existed.
 */
export const normalizeServiceLines = (source: {
  serviceLines?: unknown;
  serviceDescription?: string | null;
  hours?: string | null;
  minutes?: string | null;
}): ServiceLineItem[] => {
  if (Array.isArray(source.serviceLines) && source.serviceLines.length > 0) {
    return source.serviceLines.map((line: any) => ({
      description: line?.description ?? '',
      hours: line?.hours ?? '',
      minutes: line?.minutes ?? '',
    }));
  }

  // Legacy fallback: build one line from the old single-service fields.
  if (source.serviceDescription || source.hours || source.minutes) {
    return [
      {
        description: source.serviceDescription ?? '',
        hours: source.hours ?? '',
        minutes: source.minutes ?? '',
      },
    ];
  }

  return [];
};

/** Total minutes worked across all service lines. */
export const totalMinutes = (lines: ServiceLineItem[]): number =>
  lines.reduce(
    (sum, line) => sum + (parseFloat(line.hours) || 0) * 60 + (parseFloat(line.minutes) || 0),
    0
  );
